import { Sheet, SheetContent, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";

// Slide-in Seitenleiste (Burger-Menü) für mobile Ansichten (< lg).
export function MobileSidebar({ open, onOpenChange, children, title = "Navigation" }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="left"
        data-testid="mobile-sidebar"
        className="p-0 w-[88vw] max-w-sm flex flex-col gap-0 [&>button.absolute]:hidden"
      >
        <SheetTitle className="sr-only">{title}</SheetTitle>
        <SheetDescription className="sr-only">Seitennavigation</SheetDescription>
        {children}
      </SheetContent>
    </Sheet>
  );
}

// Schmale mobile Kopfzeile mit Burger-Button (nur < lg sichtbar).
export function BurgerBar({ onOpen, label, right, testId = "mobile-menu-btn" }) {
  return (
    <div className="xl:hidden shrink-0 flex items-center gap-2 px-3 py-2 border-b border-gray-200 bg-white">
      <Button variant="outline" size="sm" className="h-9 w-9 p-0 shrink-0" onClick={onOpen} data-testid={testId} title="Menü öffnen">
        <Menu className="h-5 w-5" />
      </Button>
      <span className="text-sm font-semibold text-gray-800 truncate flex-1 min-w-0">{label}</span>
      {right}
    </div>
  );
}
